import { useEffect, useCallback, useState } from 'react';
import {
  isOnboardingComplete,
  startTour,
  resetOnboarding
} from '../utils/onboarding';

/**
 * Custom hook for managing onboarding state and actions
 * @returns {Object} Onboarding state and methods
 */
export const useOnboarding = () => {
  const [hasCompleted, setHasCompleted] = useState(isOnboardingComplete());

  // Check completion status on mount
  useEffect(() => {
    setHasCompleted(isOnboardingComplete());
  }, []);

  // Start tour for first-time users
  const startOnboarding = useCallback((force = false) => {
    startTour(force);
    if (force) {
      setHasCompleted(false);
    }
  }, []);

  // Restart tour manually
  const restartTour = useCallback(() => {
    resetOnboarding();
    setHasCompleted(false);
    startTour(true);
  }, []);

  // Auto-start for first-time users
  useEffect(() => {
    if (!hasCompleted) {
      startOnboarding();
    }
  }, [hasCompleted, startOnboarding]);

  return {
    hasCompleted,
    startOnboarding,
    restartTour
  };
};

export default useOnboarding;

